export default __webpack_public_path__ + "static/media/ic-img.1731196f.svg";